module.exports = __webpack_public_path__ + "img/event_winner_06251.9c426ea9.png";